import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=48d0b01a"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d0b01a')) {
      api.createRecord('48d0b01a', component.options)
    } else {
      api.reload('48d0b01a', component.options)
    }
    module.hot.accept("./upgrade.vue?vue&type=template&id=48d0b01a", function () {
      api.rerender('48d0b01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/upgrade.vue"
export default component.exports